import interpolateComponents from '@automattic/interpolate-components';
import type { ReactNode } from 'react';

import { StyledVersionedRouterLink } from 'components/Link/StyledVersionedRouterLink';

type Args = {
  orgUrl: string | undefined;
  orgPublishedVolopsCount: number;
};

export function getUnpublishedVolopPageSeeMoreText({
  orgUrl,
  orgPublishedVolopsCount,
}: Args): ReactNode {
  if (!orgUrl) {
    return getText(
      'Search below for a volunteer opportunity title that interests you.',
    );
  }

  const link = (
    <StyledVersionedRouterLink
      to={orgUrl}
      data-qa-id="view-volop-page-unpublished-view-organization-opportunities"
    />
  );

  if (orgPublishedVolopsCount > 0) {
    return interpolateComponents({
      mixedString: getText(
        'You can see more {{link}}volunteer opportunities by this organization{{/link}}, or search below',
      ),
      components: { link },
    });
  }

  return interpolateComponents({
    mixedString: getText(
      'You can learn more about {{link}}the organization that posted this listing{{/link}}, or search below',
    ),
    components: { link },
  });
}
